module.exports = __webpack_public_path__ + "static/media/inf_40og52.6e9d4709.mp3";